import { render } from "./Contacto1.vue?vue&type=template&id=58fc44ec&scoped=true"
import script from "./Contacto1.vue?vue&type=script&lang=js"
export * from "./Contacto1.vue?vue&type=script&lang=js"

import "./Contacto1.vue?vue&type=style&index=0&id=58fc44ec&lang=scss&scoped=true"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58fc44ec"]])

export default __exports__